import React from 'react';

function About() {
  return (
    <div style={{ backgroundColor: '#3b3b3b', minHeight: '100vh' }}>
      <div
        className="page-content"
        style={{
          padding: '1rem',
          color: '#FFF9DB',
          textAlign: 'center' // ✅ centers text horizontally
        }}
      >
        <h1>About Pixel Creator</h1>
        <br></br>
        <h2>We offer a complete service to create low maintenance, high quality static webpages.</h2>
        <br></br>
        <h2>Services we offer include:</h2>

        <h3 style={{ lineHeight: '1.8' }}>
          &bull; Website design and build<br />
          &bull; Logo design<br />
          &bull; Graphics design<br />
          &bull; Choosing SEO keywords to aid search engine discovery<br />
          &bull; Web page name purchase (e.g., www.yourwebpage.com)<br />
          &bull; E-mail name purchase (e.g., contact@yourwebpage.com)<br />
          &bull; Ongoing website hosting
        </h3>
        <br></br>
        <h2>Contact us today to discuss your project and receive a no-obligation quote!</h2>
      </div>
    </div>
  );
}

export default About;
